// extracted by mini-css-extract-plugin
export default {"chevron-arrow-left":"ContactUsFormFooter_chevron-arrow-left__diTZc"};